import React, { useEffect } from 'react'
import { ModalHeader, ModalBody } from 'reactstrap'
import Lang from 'Lang/General'

import ReactTable from 'react-table'
import Moment from 'moment'

function LogContent(props) {

  useEffect(() => {
  }, [])

  return (
    <>
      <ModalHeader toggle={() => props.onClose()} >
        {Lang['LOG'][props.data.languageReducer.userSettings.admin_panel_language]}
      </ModalHeader>
      <ModalBody>
        <ReactTable
          defaultPageSize={10}
          pageSize={10}
          showPagination={true}
          NoDataComponent={() => <span></span>}
          data={props.logRecords}
          columns={[
            {
              Header: Lang['ROLE'][props.data.languageReducer.userSettings.admin_panel_language],
              accessor: 'role',
              Cell: row => (
                Lang?.[row.original.role]?.[props.data.languageReducer.userSettings.admin_panel_language] ?? ''
              )
            },
            {
              Header: Lang['EMAIL'][props.data.languageReducer.userSettings.admin_panel_language],
              accessor: 'email'
            },
            {
              Header: Lang['FORM'][props.data.languageReducer.userSettings.admin_panel_language],
              accessor: 'form_name',
              Cell: row => (
                Lang[row.original.form_name][props.data.languageReducer.userSettings.admin_panel_language]
              )
            },

            {
              Header: Lang['ACTION'][props.data.languageReducer.userSettings.admin_panel_language],
              accessor: 'action',
              Cell: row => (
                Lang[row.original.action][props.data.languageReducer.userSettings.admin_panel_language]
              )
            }, {
              Header: Lang['UPDATED_AT'][props.data.languageReducer.userSettings.admin_panel_language],
              accessor: 'created_at',
              Cell: row => (
                Moment(row.original.created_at).format('DD-MM-YYYY h:mm:ss a')
              )
            },
          ]}
        />
      </ModalBody>
    </>
  )
}

export default LogContent